import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ENVIRONMENT } from '@ninety/mobile/platform/environments';

import { HeadlineModel } from './models';

@Injectable({
  providedIn: 'root',
})
export class HeadlinesSharedApiService {
  private readonly http = inject(HttpClient);
  private readonly environment = inject(ENVIRONMENT);

  headlineApiUrl = `${this.environment.origin.monolith}/Headlines`;

  createHeadline(headline: Partial<HeadlineModel>): Observable<HeadlineModel[]> {
    return this.http.post<HeadlineModel[]>(this.headlineApiUrl, { models: [headline], from: headline.from });
  }
}
